import React from "react";

import "./otherSites.css";

import { useNavigate, NavLink, Navigate } from "react-router-dom";


const BeneficiosSites = () => {
    const navigate = useNavigate();
    return (
        <>
       <div class="container text-center mainContent" >
       <h1>Beneficios, click en la imagen para volver</h1>
            <div class="row">
                <div class="col-4"><img className="imageClip" src="./icon-turnos.png" onClick={() =>navigate("/")}/></div>
       </div>
          
          
        </div>
        
        </>

    );
    }
export default BeneficiosSites;